import { trackEvent } from '@/analytics/track'
import { unescape } from 'lodash'

window.Agra = window.Agra || {}
window.Agra.trackEvent = trackEvent

window.Agra.alertMessageSuccess = function (message) {
  const clientSideAlerts = document.querySelector('.client-side-alerts')
  if (clientSideAlerts) {
    clientSideAlerts.querySelector('.alert').style.display = 'none'
    clientSideAlerts.querySelector('.alert.alert-success > span').innerText = unescape(message)
    clientSideAlerts.querySelector('.alert.alert-success').style.display = 'block'
  }
}

window.Agra.alertMessageDanger = function (message) {
  const clientSideAlerts = document.querySelector('.client-side-alerts')
  if (clientSideAlerts) {
    clientSideAlerts.querySelector('.alert').style.display = 'none'
    clientSideAlerts.querySelector('.alert.alert-danger > span').innerText = unescape(message)
    clientSideAlerts.querySelector('.alert.alert-danger').style.display = 'block'
  }
}

const FADE_OUT_DURATION = 400

// Timers pending for each tick, so that flashing a tick that is still on screen doesn't leave the
// previous call's timers behind to hide it too early.
const pendingSuccessCheckTimers = new WeakMap()

function hideSuccessCheck (successCheck) {
  successCheck.style.display = 'none'
  successCheck.style.transition = ''
  successCheck.style.opacity = ''
}

function cancelPendingSuccessCheckTimers (successCheck) {
  const timers = pendingSuccessCheckTimers.get(successCheck)
  if (timers) {
    timers.forEach((timer) => clearTimeout(timer))
    pendingSuccessCheckTimers.delete(successCheck)
  }
}

// Show the tick inside `container` (element or selector), then fade it out after `delay` ms.
window.Agra.flashSuccessCheck = function (container, delay = 1000) {
  const scope = typeof container === 'string' ? document.querySelector(container) : container
  const successCheck = scope && scope.querySelector('.success-check')
  if (!successCheck) return

  cancelPendingSuccessCheckTimers(successCheck)

  // Animations are disabled in tests, where fading the tick out only makes it harder to assert on.
  const fadeOutDuration = window.Agra.Configuration?.disableAnimations ? 0 : FADE_OUT_DURATION

  successCheck.style.transition = ''
  successCheck.style.opacity = ''
  successCheck.style.display = ''
  if (getComputedStyle(successCheck).display === 'none') {
    successCheck.style.display = 'inline-block'
  }

  const timers = []
  timers.push(setTimeout(() => {
    if (fadeOutDuration === 0) {
      hideSuccessCheck(successCheck)
      return
    }

    successCheck.style.transition = `opacity ${fadeOutDuration / 1000}s ease-out`
    successCheck.style.opacity = '0'
    timers.push(setTimeout(() => hideSuccessCheck(successCheck), fadeOutDuration))
  }, delay))
  pendingSuccessCheckTimers.set(successCheck, timers)
}
